module.exports = __webpack_public_path__ + "img/newLogo-white.bd71afcd.png";